import { render, staticRenderFns } from "./PrepProcessForm.vue?vue&type=template&id=5c8e4ac5"
import script from "./PrepProcessForm.vue?vue&type=script&lang=js"
export * from "./PrepProcessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports